import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import React from "react";
import { MenuOptionType } from "../../../../../controls";
import { EmailTopic } from "../../models/EmailTopic";

type Props = {
	setTopicSelected: Function;
	setShowDeleteModal: Function;
	setShowCreateModal: Function;
	setShowEditModal: Function;
};

export const useEmailTopicsOptionsFunctions = ({
	setTopicSelected,
	setShowDeleteModal,
	setShowCreateModal,
	setShowEditModal,
}: Props) => {
	const getMenuOptions = (data: EmailTopic) => {
		const newOption: MenuOptionType = {
			name: "New Topic",
			key: "new_topic",
			onClick: () => {
				setShowCreateModal(true);
			},
			icon: <PlaylistAddIcon />,
		};

		if (!data) return [newOption];

		return [
			newOption,
			{
				name: "Edit Topic",
				key: "edit_topic",
				onClick: () => {
					setTopicSelected(data);
					setShowEditModal(true);
				},
				icon: <EditIcon />,
			},
			{
				name: "Delete Topic",
				key: "delete_topic",
				onClick: () => {
					setTopicSelected(data);
					setShowDeleteModal(true);
				},
				icon: <DeleteIcon />,
			},
		] as MenuOptionType[];
	};

	return { getMenuOptions };
};
